import { render, staticRenderFns } from "./CategoryIndex.vue?vue&type=template&id=2066a0a8"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports